/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  disabledEnabledError,
  enableTotp,
} from "../../../redux/features/totp/totp";
import "./index.css";

import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

const TotpVerify = ({
  isFocus,
  setIsFocus,
  totp,
  setTotp,
  userId,
  setBackupCodes,
  enableTotpLoading,
  enableTotpData,
  enableTotpError,
  handleNext,
}) => {
  const dispatch = useDispatch();

  const handleVerify = (e) => {
    e.preventDefault();

    dispatch(enableTotp({ id: userId, totp: totp }));
  };

  useEffect(() => {
    if (!enableTotpLoading && enableTotpData?.status) {
      // handleNext();
    }
  }, [enableTotpData]);

  const handleTotpChange = (e) => {
    let value = e.target.value;
    if (/^\d*$/.test(value) && value?.length <= 6) {
      if (enableTotpError === true) {
        dispatch(disabledEnabledError());
      }
      setTotp(value);
    }
  };

  useEffect(() => {
    if (enableTotpData?.status === true && !enableTotpLoading) {
      setBackupCodes(enableTotpData?.data?.backup_codes);
    }
  }, [enableTotpData, enableTotpLoading]);
  return (
    <div className="totp-top-main">
      <div className="divide-totp ">
        <div
          className="rounded-border-radius-md"
          style={{
            backgroundColor:
              enableTotpError === true ? "var(--negative-card)" : "transparent",
            height: "auto",
          }}
        >
          <div className="totp-verify-main-div">
            <h4>Authentication Code</h4>
            <p>
              Enter the 6-digit code generated by the authenticator app and
              verify
            </p>
            <div className="totp_verify_input_div flex flex-col gap-gap-md">
              <div className="input-field-totp">
                <TextInputField
                  isFullWidth
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  placeholder="6 digit code"
                  value={totp}
                  onInput={(e) => handleTotpChange(e)}
                  variant={
                    enableTotpError === true && !enableTotpLoading
                      ? "error"
                      : enableTotpData?.status === true && !enableTotpLoading
                        ? "verified"
                        : "default"
                  }
                  fontKind="big"
                  isDisabled={enableTotpData?.status === true}
                />
              </div>
              <PrimaryButton
                btnText="Verify code"
                btnType="submit"
                disabledBgColor="var(--text-disabled)"
                isLoaderNeeded
                isLoading={enableTotpLoading}
                hoverOption="black"
                enabledBgColor="var(--positive-act)"
                enabledTextColor="var(--text-primary)"
                handleFunction={(e) => {
                  if (
                    totp.length !== 6 ||
                    enableTotpError ||
                    enableTotpData?.status === true
                  ) {
                    return;
                  }

                  handleVerify(e);
                }}
                isDisabled={
                  totp.length !== 6 ||
                  enableTotpError ||
                  enableTotpData?.status === true
                }
                fullWidthRequired
                inActiveVariantNeeded={enableTotpData?.status}
              />
            </div>
          </div>
          <div
            className="totp-verify-left-error-msg"
            style={{ display: enableTotpError === true ? "flex" : "none" }}
          >
            <img
              className="totp-verify-left-error-msg-left"
              src={ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
              alt="ErrorIcon"
            ></img>
            <div className="totp-verify-left-error-msg-right flex flex-col gap-gap-xs">
              <h4>VERIFICATION FAILED</h4>
              <ul>
                <li className="totp-list">Invalid code</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="divide-totp">
        <div className="totp-verify-right">
          <SVGComponent
            url={ICONS?.ENTER_CODE}
            height={"var(--graphic-square-height-md)"}
            width={"var(--graphic-width-md)"}
          />
        </div>
      </div>
    </div>
  );
};

export default TotpVerify;
